<script setup lang="ts">
import { storeToRefs } from 'pinia'
import type { Lead } from '@/types/types'
import { useOnlineStore } from '@/stores/online'
import { useRegisteredStore } from '@/stores/registered'

defineProps<{
  show: boolean
  lead: Lead | null
  errorMessage: string | null
  isMakingCall: boolean
}>()

const emit = defineEmits<{
  cancel: []
  confirm: []
}>()

const { online } = storeToRefs(useOnlineStore())
const { registered } = storeToRefs(useRegisteredStore())
</script>

<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-black/40 z-[9999] flex items-center justify-center"
    @click.self="emit('cancel')"
  >
    <div
      class="bg-white rounded-[16px] w-[min(430px,calc(100vw-32px))] pt-[28px] px-[16px] pb-[16px]"
    >
      <p class="text-[18px] text-[#333] mt-0 mx-0 mb-[24px] text-center leading-[1.4]">
        Are you sure you want to call
        <strong>{{
          lead?.label || [lead?.fname, lead?.lname].filter(Boolean).join(' ') || lead?.phone_number
        }}</strong
        >?
      </p>

      <div v-if="errorMessage" class="text-[#a94442] text-center mb-[12px]">
        <strong>{{ errorMessage }}</strong>
      </div>

      <div class="flex gap-[10px]">
        <button
          class="flex-1 py-[10px] px-0 border-none rounded-none bg-[#b53a3a] text-white text-[18px] font-medium cursor-pointer"
          @click="emit('cancel')"
        >
          Cancel
        </button>
        <button
          class="flex-1 py-[10px] px-0 border-none rounded-none bg-[#3882b5] text-white text-[18px] font-medium cursor-pointer"
          :disabled="isMakingCall || !online || !registered"
          :style="{ opacity: isMakingCall || !online || !registered ? 0.6 : 1 }"
          @click="emit('confirm')"
        >
          {{ isMakingCall ? 'Calling...' : 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</template>
